import { cn } from "@/lib/utils";

type BadgeMode = "success" | "pending" | "warning" | "error" | "info";

interface StatusBadgeProps {
  label?: string;
  mode?: BadgeMode;

  /**
   * Override styles
   */
  dotColor?: string;
  textColor?: string;
  bgColor?: string;
  padding?: string;
  className?: string;
  labelClassName?: string;
  dotClassName?: string;
}

const BADGE_VARIANTS: Record<
  BadgeMode,
  {
    textColor: string;
    bgColor: string;
    padding?: string;
  }
> = {
  success: {
    textColor: "text-[#000000]",
    bgColor: "bg-[#43946C]",
    padding: "px-[15px]",
  },

  pending: {
    textColor: "text-[#000000E8]",
    bgColor: "bg-[#EBEBEB]",
    padding: "px-[10px]",
  },

  warning: {
    textColor: "text-[#93370D]",
    bgColor: "bg-[#FFFAEB]",
  },

  error: {
    textColor: "text-[#B42318]",
    bgColor: "bg-[#FEF3F2]",
  },

  info: {
    textColor: "text-[#175CD3]",
    bgColor: "bg-[#EFF8FF]",
  },
};

export const StatusBadge = ({
  label,
  mode = "pending",

  /**
   * Override variant styles
   */
  dotColor,
  textColor,
  bgColor,
  padding,
  className,
  labelClassName,
  dotClassName,
}: StatusBadgeProps) => {
  const variant = BADGE_VARIANTS[mode];

  return (
    <div
      className={cn(
        "inline-flex items-center gap-[6px] rounded-[4px]",
        padding || variant.padding,
        bgColor || variant.bgColor,
        className,
      )}
    >
      <span
        className={cn(
          "text-[14px] font-medium leading-none",
          textColor || variant.textColor,
          labelClassName,
        )}
      >
        {label}
      </span>
    </div>
  );
};

export default StatusBadge;
